import {FC} from 'react'
import {useIntl} from 'react-intl'
import {IStockRequest, StockRequestStatusCode, isStockRequestStatus} from '../core/_models'

const BADGE_CLASS: Record<StockRequestStatusCode, string> = {
  pending: 'badge-light-warning',
  approved: 'badge-light-success',
  rejected: 'badge-light-danger',
}

type Props = {
  request: Pick<IStockRequest, 'status_code' | 'status' | 'stage_label' | 'reason'>
}

const StockRequestStatus: FC<Props> = ({request}) => {
  const {formatMessage} = useIntl()
  const code = isStockRequestStatus(request.status_code) ? request.status_code : null
  const label =
    request.status?.trim() ||
    (code ? formatMessage({id: `add_to_stock.status.${code}`}) : request.status_code)

  return (
    <div className='d-flex flex-column align-items-start'>
      <span className={`badge ${code ? BADGE_CLASS[code] : 'badge-light'}`}>{label}</span>
      {code === 'pending' && request.stage_label && (
        <span className='text-muted fs-8 mt-1'>{request.stage_label}</span>
      )}
      {code === 'rejected' && (
        <span className='text-danger fs-7 mt-1'>
          <span className='fw-bold'>{formatMessage({id: 'reason'})}:</span>{' '}
          {request.reason?.trim() || '—'}
        </span>
      )}
    </div>
  )
}

export default StockRequestStatus
